import React from 'react';

const TEMPLATES = [
  { id:'paid_media', label:'Paid Media Expose', bg:'#1a0000', text1:'PAID MEDIA ALERT!', text2:'This channel is funded by political parties', emoji:'🚨', color:'#ff4444' },
  { id:'truth_bomb', label:'Truth Bomb', bg:'#000a1a', text1:'TRUTH BOMB', text2:'They dont want you to know this', emoji:'💣', color:'#f5c842' },
  { id:'dmk_expose', label:'DMK Expose', bg:'#0a0005', text1:'DMK CONTROLLED MEDIA', text2:'Sun TV = Kalanithi Maran = DMK', emoji:'📺', color:'#cc2222' },
  { id:'admk_expose', label:'ADMK Expose', bg:'#000510', text1:'ADMK FUNDED CHANNEL', text2:'Jaya TV = Party Propaganda', emoji:'📢', color:'#ff6600' },
  { id:'nethaji_truth', label:'Nethaji Prime', bg:'#0a0800', text1:'NETHAJI TV', text2:'Unbiased | Anti-Corruption | Truth', emoji:'🏆', color:'#d4a843' },
  { id:'neet_protest', label:'NEET Protest', bg:'#000a00', text1:'FIGHT FOR JUSTICE', text2:'Tamil Nadu against NEET', emoji:'✊', color:'#00cc66' },
  { id:'politics_facts', label:'Political Facts', bg:'#05000a', text1:'POLITICAL FACTS', text2:'Share before they delete this', emoji:'📊', color:'#cc44ff' },
  { id:'cinema_meme', label:'Cinema Meme', bg:'#0a0500', text1:'KOLLYWOOD TRUTH', text2:'Behind the scenes reality', emoji:'🎬', color:'#ff9900' },
];

const STICKERS = ['🔥','💯','⚡','🚨','💣','🎯','👁️','🤔','😮','😤','💪','🙏','🏆','📢','🚫','⚠️','✅','❌'];

const AI_PROMPTS = [
  'Generate viral Tamil political meme caption about paid media',
  'Create funny meme text about DMK and Sun TV connection',
  'Write sarcastic meme about politicians and media',
  'Generate truth bomb meme text about Tamil Nadu politics',
];

function AdvancedMemeGenerator({ onBack, user }) {
  const canvasRef = React.useRef(null);
  const [template, setTemplate] = React.useState(TEMPLATES[0]);
  const [topText, setTopText] = React.useState('PAID MEDIA ALERT!');
  const [bottomText, setBottomText] = React.useState('This channel is funded by political parties');
  const [middleText, setMiddleText] = React.useState('');
  const [textColor, setTextColor] = React.useState('#ffffff');
  const [fontSize, setFontSize] = React.useState(36);
  const [selectedStickers, setSelectedStickers] = React.useState([]);
  const [bgImage, setBgImage] = React.useState(null);
  const [aiLoading, setAiLoading] = React.useState(false);
  const [aiCaption, setAiCaption] = React.useState('');
  const [situation, setSituation] = React.useState('');
  const [strokeColor, setStrokeColor] = React.useState('#000000');
  const [fontStyle, setFontStyle] = React.useState('Impact');
  const [generated, setGenerated] = React.useState(false);

  const drawMeme = React.useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    canvas.width = 800;
    canvas.height = 600;

    if (bgImage) {
      const img = new Image();
      img.onload = () => {
        ctx.drawImage(img, 0, 0, 800, 600);
        drawText(ctx);
      };
      img.src = bgImage;
    } else {
      // Draw gradient background
      const grad = ctx.createLinearGradient(0, 0, 800, 600);
      grad.addColorStop(0, template.bg);
      grad.addColorStop(0.5, '#0a0a0a');
      grad.addColorStop(1, template.bg);
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, 800, 600);

      // Border
      ctx.strokeStyle = template.color;
      ctx.lineWidth = 6;
      ctx.strokeRect(3, 3, 794, 594);

      // Inner glow
      ctx.strokeStyle = template.color + '44';
      ctx.lineWidth = 2;
      ctx.strokeRect(12, 12, 776, 576);

      // Watermark
      ctx.font = '14px Arial';
      ctx.fillStyle = 'rgba(255,255,255,0.15)';
      ctx.textAlign = 'center';
      ctx.fillText('nethajiprime.com | Nethaji IQ', 400, 585);

      drawText(ctx);
    }
    setGenerated(true);
  }, [template, topText, bottomText, middleText, textColor, fontSize, strokeColor, fontStyle, bgImage, selectedStickers]);

  function drawText(ctx) {
    const drawStrokeText = (text, x, y, size) => {
      ctx.font = `bold ${size}px ${fontStyle}`;
      ctx.textAlign = 'center';
      ctx.strokeStyle = strokeColor;
      ctx.lineWidth = size / 8;
      ctx.lineJoin = 'round';
      ctx.strokeText(text, x, y);
      ctx.fillStyle = textColor;
      ctx.fillText(text, x, y);
    };

    if (topText) drawStrokeText(topText, 400, fontSize + 30, fontSize);
    if (middleText) drawStrokeText(middleText, 400, 310, fontSize - 4);
    if (bottomText) drawStrokeText(bottomText, 400, 600 - 30, fontSize - 4);

    // Draw stickers
    ctx.font = '48px Arial';
    ctx.textAlign = 'left';
    selectedStickers.forEach((s, i) => {
      ctx.fillText(s, 20 + (i % 3) * 60, 100 + Math.floor(i / 3) * 60);
    });

    // Big emoji watermark
    if (!bgImage) {
      ctx.font = '120px Arial';
      ctx.textAlign = 'center';
      ctx.globalAlpha = 0.08;
      ctx.fillStyle = '#ffffff';
      ctx.fillText(template.emoji, 400, 340);
      ctx.globalAlpha = 1;
    }
  }

  React.useEffect(() => { drawMeme(); }, [drawMeme]);

  const generateAICaption = async () => {
    if (!situation.trim()) { alert('Describe the situation first!'); return; }
    setAiLoading(true);
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';
      const resp = await fetch(API_URL + '/api/meme-captions?topic=' + encodeURIComponent(situation));
      const data = await resp.json();
      if (data.captions && data.captions.length > 0) {
        setTopText(data.captions[0] || topText);
        setBottomText(data.captions[1] || bottomText);
        setMiddleText(data.captions[2] || "");
        setAiCaption("AI caption generated!");
      } else {
        setAiCaption('Error: ' + (data.error || 'Try again'));
      }
    } catch (e) {
      setAiCaption('Error: ' + e.message);
    }
    setAiLoading(false);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setBgImage(ev.target.result);
    reader.readAsDataURL(file);
  };

  const downloadMeme = () => {
    const canvas = canvasRef.current;
    const link = document.createElement('a');
    link.download = 'nethajiprime-meme.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const shareWhatsApp = () => {
    const canvas = canvasRef.current;
    canvas.toBlob(blob => {
      if (navigator.share && navigator.canShare) {
        const file = new File([blob], 'meme.png', { type: 'image/png' });
        if (navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: 'Nethaji Prime Meme', text: 'Check out this meme from Nethaji Prime OTT! nethajiprime.com' });
          return;
        }
      }
      const msg = encodeURIComponent(topText + '\n\n' + bottomText + '\n\nMore at: https://nethajiprime.com');
      window.open('https://wa.me/?text=' + msg, '_blank');
    });
  };

  const S = {
    page: { background: '#070707', minHeight: '100vh', color: '#f0e6cc', fontFamily: "'Barlow', sans-serif" },
    hdr: { background: 'rgba(7,7,7,0.98)', borderBottom: '1px solid rgba(212,168,67,0.2)', padding: '0 4%', height: '60px', display: 'flex', alignItems: 'center', gap: '12px', position: 'sticky', top: 0, zIndex: 100 },
    section: { background: 'rgba(255,255,255,0.03)', borderRadius: '12px', padding: '16px', marginBottom: '12px', border: '1px solid rgba(255,255,255,0.07)' },
    label: { color: 'rgba(255,255,255,0.5)', fontSize: '11px', fontWeight: '700', letterSpacing: '2px', marginBottom: '8px', display: 'block' },
    input: { width: '100%', padding: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#fff', fontSize: '13px', marginBottom: '8px', boxSizing: 'border-box' },
    btn: (color) => ({ padding: '10px 20px', background: color || 'rgba(212,168,67,0.15)', border: '1px solid rgba(212,168,67,0.3)', borderRadius: '8px', color: '#d4a843', fontWeight: '700', cursor: 'pointer', fontSize: '13px' }),
  };

  return (
    <div style={S.page}>
      <div style={S.hdr}>
        <button onClick={onBack} style={{ background: 'none', border: '1px solid rgba(212,168,67,0.3)', color: '#d4a843', padding: '6px 16px', borderRadius: '20px', cursor: 'pointer', fontSize: '12px', fontWeight: '700' }}>Back</button>
        <span style={{ fontFamily: "'Cinzel', serif", fontSize: '1.2em', fontWeight: '900', color: '#f5c842' }}>AI Meme Generator</span>
        <span style={{ background: 'linear-gradient(135deg,#9900cc,#cc44ff)', color: '#fff', fontSize: '9px', fontWeight: '800', padding: '2px 8px', borderRadius: '10px' }}>AI POWERED</span>
      </div>

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '20px 4%' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,340px)', gap: '20px' }}>
          
          {/* Left - Canvas */}
          <div>
            <div style={{ borderRadius: '12px', overflow: 'hidden', border: '2px solid rgba(212,168,67,0.3)', marginBottom: '12px' }}>
              <canvas ref={canvasRef} style={{ width: '100%', display: 'block' }} />
            </div>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button onClick={downloadMeme} style={{ flex: 1, padding: '12px', background: 'linear-gradient(135deg,#d4a843,#b8922e)', border: 'none', borderRadius: '8px', color: '#000', fontWeight: '900', cursor: 'pointer', fontSize: '14px' }}>Download HD</button>
              <button onClick={shareWhatsApp} style={{ flex: 1, padding: '12px', background: 'linear-gradient(135deg,#25d366,#128c7e)', border: 'none', borderRadius: '8px', color: '#fff', fontWeight: '900', cursor: 'pointer', fontSize: '14px' }}>Share WhatsApp</button>
            </div>
          </div>

          {/* Right - Controls */}
          <div style={{ overflowY: 'auto', maxHeight: '80vh' }}>
            
            {/* AI Caption Generator */}
            <div style={{ ...S.section, border: '1px solid rgba(153,0,204,0.3)', background: 'rgba(153,0,204,0.05)' }}>
              <span style={{ color: '#cc44ff', fontSize: '12px', fontWeight: '900', letterSpacing: '2px', display: 'block', marginBottom: '10px' }}>AI CAPTION GENERATOR</span>
              <textarea value={situation} onChange={e => setSituation(e.target.value)} placeholder="Describe the situation... e.g. Sun TV showing only DMK news during election" style={{ ...S.input, height: '70px', resize: 'vertical' }} />
              <button onClick={generateAICaption} disabled={aiLoading} style={{ width: '100%', padding: '10px', background: 'linear-gradient(135deg,#9900cc,#cc44ff)', border: 'none', borderRadius: '8px', color: '#fff', fontWeight: '900', cursor: 'pointer', fontSize: '13px' }}>
                {aiLoading ? 'Generating...' : 'Generate AI Caption'}
              </button>
              {aiCaption && <div style={{ color: '#00cc88', fontSize: '12px', marginTop: '6px' }}>{aiCaption}</div>}
            </div>

            {/* Templates */}
            <div style={S.section}>
              <span style={S.label}>TEMPLATES</span>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px' }}>
                {TEMPLATES.map(t => (
                  <button key={t.id} onClick={() => { setTemplate(t); setTopText(t.text1); setBottomText(t.text2); }} style={{ padding: '8px', background: template.id === t.id ? 'rgba(212,168,67,0.2)' : 'rgba(255,255,255,0.04)', border: '1px solid ' + (template.id === t.id ? '#d4a843' : 'rgba(255,255,255,0.08)'), borderRadius: '8px', color: template.id === t.id ? '#f5c842' : 'rgba(255,255,255,0.6)', cursor: 'pointer', fontSize: '11px', fontWeight: '700', textAlign: 'left' }}>
                    {t.emoji} {t.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Text Inputs */}
            <div style={S.section}>
              <span style={S.label}>TEXT CONTENT</span>
              <input value={topText} onChange={e => setTopText(e.target.value)} placeholder="Top text" style={S.input} />
              <input value={middleText} onChange={e => setMiddleText(e.target.value)} placeholder="Middle text (optional)" style={S.input} />
              <input value={bottomText} onChange={e => setBottomText(e.target.value)} placeholder="Bottom text" style={S.input} />
            </div>

            {/* Style Controls */}
            <div style={S.section}>
              <span style={S.label}>STYLE</span>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', marginBottom: '8px' }}>
                <div>
                  <span style={{ ...S.label, marginBottom: '4px' }}>Text Color</span>
                  <input type="color" value={textColor} onChange={e => setTextColor(e.target.value)} style={{ width: '100%', height: '36px', borderRadius: '6px', border: 'none', cursor: 'pointer' }} />
                </div>
                <div>
                  <span style={{ ...S.label, marginBottom: '4px' }}>Stroke Color</span>
                  <input type="color" value={strokeColor} onChange={e => setStrokeColor(e.target.value)} style={{ width: '100%', height: '36px', borderRadius: '6px', border: 'none', cursor: 'pointer' }} />
                </div>
              </div>
              <span style={{ ...S.label, marginBottom: '4px' }}>Font Size: {fontSize}px</span>
              <input type="range" min="20" max="72" step="2" value={fontSize} onChange={e => setFontSize(+e.target.value)} style={{ width: '100%', marginBottom: '8px' }} />
              <select value={fontStyle} onChange={e => setFontStyle(e.target.value)} style={{ ...S.input, marginBottom: 0 }}>
                <option value="Impact">Impact (Classic Meme)</option>
                <option value="Arial Black">Arial Black (Bold)</option>
                <option value="Georgia">Georgia (Elegant)</option>
                <option value="Comic Sans MS">Comic Sans (Fun)</option>
                <option value="Courier New">Courier New (News)</option>
              </select>
            </div>

            {/* Background Image */}
            <div style={S.section}>
              <span style={S.label}>BACKGROUND IMAGE</span>
              <input type="file" accept="image/*" onChange={handleImageUpload} style={{ ...S.input, padding: '6px' }} />
              {bgImage && <button onClick={() => setBgImage(null)} style={{ ...S.btn(), width: '100%', marginTop: '4px', color: '#ff4444', borderColor: 'rgba(255,0,0,0.3)' }}>Remove Image</button>}
            </div>

            {/* Stickers */}
            <div style={S.section}>
              <span style={S.label}>STICKERS (click to add)</span>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
                {STICKERS.map((s, i) => (
                  <button key={i} onClick={() => setSelectedStickers(prev => prev.length < 6 ? [...prev, s] : prev)} style={{ fontSize: '20px', padding: '4px 6px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '6px', cursor: 'pointer' }}>{s}</button>
                ))}
              </div>
              {selectedStickers.length > 0 && (
                <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                  <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px' }}>Added: {selectedStickers.join(' ')}</span>
                  <button onClick={() => setSelectedStickers([])} style={{ padding: '3px 8px', background: 'rgba(255,0,0,0.1)', border: '1px solid rgba(255,0,0,0.2)', borderRadius: '4px', color: '#ff4444', fontSize: '10px', cursor: 'pointer' }}>Clear</button>
                </div>
              )}
            </div>

            {/* Regenerate */}
            <button onClick={drawMeme} style={{ width: '100%', padding: '12px', background: 'rgba(212,168,67,0.1)', border: '1px solid rgba(212,168,67,0.3)', borderRadius: '8px', color: '#f5c842', fontWeight: '900', cursor: 'pointer', fontSize: '14px' }}>
              Refresh Preview
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdvancedMemeGenerator;


